export default "__VITE_ASSET__f24d3914__"